export default "/_next/static/5445c7839593c8d030b3454710bacaec.png";